import type { IRowNode } from 'ag-grid-enterprise';
import type { RoadmapTableData } from '../../interfaces/event';

type TableGroupingSorterType = (valueA: any, valueB: any, nodeA: IRowNode<RoadmapTableData>, nodeB: IRowNode<RoadmapTableData>, isInverted: boolean) => number;

export const tableGroupingSorter: TableGroupingSorterType = (a, b, nodeA, nodeB) => {
    const aGroup = nodeA.key;
    const bGroup = nodeB.key;

    if (aGroup === bGroup) return a > b ? 1 : -1;

    return 0;
};
